"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclosureStage = exports.ContributorType = exports.SignoffStatus = void 0;
var SignoffStatus;
(function (SignoffStatus) {
    SignoffStatus["PENDING"] = "PENDING";
    SignoffStatus["APPROVED"] = "APPROVED";
    SignoffStatus["REJECTED"] = "REJECTED";
})(SignoffStatus || (exports.SignoffStatus = SignoffStatus = {}));
var ContributorType;
(function (ContributorType) {
    ContributorType["ENABLER"] = "ENABLER";
    ContributorType["CONTRIBUTOR"] = "CONTRIBUTOR";
})(ContributorType || (exports.ContributorType = ContributorType = {}));
var DisclosureStage;
(function (DisclosureStage) {
    DisclosureStage["EDIT"] = "EDIT";
    DisclosureStage["INITIAL_REVIEW"] = "INITIAL_REVIEW";
    DisclosureStage["COLAB_APPROVAL"] = "COLAB_APPROVAL";
    DisclosureStage["DEPT_APPROVAL"] = "DEPT_APPROVAL";
    DisclosureStage["FACULTY_APPROVAL"] = "FACULTY_APPROVAL";
    DisclosureStage["DRD_APPROVAL"] = "DRD_APPROVAL";
    DisclosureStage["DIRECTOR_APPROVAL"] = "DIRECTOR_APPROVAL";
    DisclosureStage["DUE_DILIGENCE"] = "DUE_DILIGENCE";
    DisclosureStage["TTO_DIRECTOR_REVIEW"] = "TTO_DIRECTOR_REVIEW";
    DisclosureStage["DEATHROW"] = "DEATHROW";
    DisclosureStage["APPROVED"] = "APPROVED";
    DisclosureStage["REJECTED"] = "REJECTED";
})(DisclosureStage || (exports.DisclosureStage = DisclosureStage = {}));
